// @flow
import ModalExtended from './ModalExtended';
import ModalExtendedHeader from './ModalExtendedHeader';
import ModalExtendedWSearch from './ModalExtendedWSearch';

export default ModalExtended;
export { ModalExtendedHeader, ModalExtendedWSearch };
